import { isRouteErrorResponse, useRouteError } from 'react-router';
import { Button } from './ui';

/** Shown if a page crashes or fails to load (e.g. a new version was deployed while the tab was open). */
export function RouteError() {
  const error = useRouteError();
  const chunkFailed = error instanceof Error && /dynamically imported module|Failed to fetch/i.test(error.message);
  return (
    <div className="flex h-full flex-col items-center justify-center px-6 text-center">
      <h1 className="text-xl font-semibold">
        {chunkFailed ? 'A new version of AI CRM is available' : 'Something went wrong on this page'}
      </h1>
      <p className="mt-2 max-w-md text-slate-600 dark:text-slate-400">
        {chunkFailed
          ? 'Please reload to get the latest version.'
          : isRouteErrorResponse(error)
            ? error.statusText
            : 'Reloading usually fixes it. If it keeps happening, please contact support.'}
      </p>
      <Button className="mt-6" onClick={() => window.location.reload()}>Reload page</Button>
    </div>
  );
}
